import { getStatsSummary } from '../../../../extranjero/CountryCards/helpers'

export const getElectionResults = ({
  electionData,
  label,
  mobileLabel,
  optionA,
  optionB,
  shortLabel,
}) => {
  const stats = getVotesSummary(electionData, optionA, optionB)
  const { padron, total, totalBlank, totalNull, totalOptionA, totalOptionB, totalValid } = stats
  const results = {
    label,
    mobileLabel,
    options: [
      {
        cantidad: totalOptionA,
        color: optionA.color,
        label: optionA.shortLabel || optionA.label,
        porcentaje: totalOptionA / totalValid,
      },
      {
        cantidad: totalOptionB,
        color: optionB.color,
        label: optionB.shortLabel || optionB.label,
        porcentaje: totalOptionB / totalValid,
      },
    ],
    participation: {
      cantidad: total,
      porcentaje: total / padron,
      totalVotes: padron,
    },
    shortLabel: shortLabel || label,
    totalVotes: totalValid,
    totalBlank,
    totalNull,
  }
  return results
}

export const getVotesSummary = getStatsSummary
